import * as mutationTypes from './types/mutation_types';
import * as actionsTypes from './types/action_types';
import * as getterTypes from './types/getter_types';

import { deleteMeal, fetchMeals, storeMeal, updateMeal } from '../services/meals';

export default {
  async [actionsTypes.FETCH_MEALS]({ commit }, options) {
    commit(mutationTypes.MEALS_REQUEST);
    const result = await fetchMeals(options).catch((e) => {
      commit(mutationTypes.MEALS_ERROR, e);
    });
    if (result) {
      commit(mutationTypes.MEALS_SUCCESS, result);
    }
    return result;
  },
  async [actionsTypes.STORE_MEAL]({ commit, getters }, payload) {
    commit(mutationTypes.MEALS_REQUEST);
    const result = await storeMeal(payload).catch((e) => {
      commit(mutationTypes.MEALS_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data.unshift(result.data);
      commit(mutationTypes.MEALS_SUCCESS, categories);
    }
    return result;
  },
  async [actionsTypes.UPDATE_MEAL]({ commit, getters }, payload) {
    const { id } = getters[getterTypes.SELECTED];
    commit(mutationTypes.MEALS_REQUEST);
    await updateMeal(id, payload).catch((e) => {
      commit(mutationTypes.MEALS_ERROR, e);
    });
    commit(mutationTypes.MEALS_SUCCESS, getters[getterTypes.DATA]);
  },
  async [actionsTypes.DELETE_MEAL]({ commit, getters }, id) {
    commit(mutationTypes.MEALS_REQUEST);
    const result = await deleteMeal(id).catch((e) => {
      commit(mutationTypes.MEALS_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data = categories.data.filter((branch) => branch.id !== id);
      commit(mutationTypes.MEALS_SUCCESS, categories);
    }
    return result;
  },
  [actionsTypes.SELECT_MEAL]({ commit }, payload) {
    commit(mutationTypes.MEALS_SELECT, payload);
  },
  [actionsTypes.SELECT_MEAL_RESET]({ commit }) {
    commit(mutationTypes.MEALS_SELECT_RESET);
  },
};
